import { useQuery } from "@tanstack/react-query";
import { startOfYear, endOfYear } from "date-fns";
import { gqlQuery, toAWSDate } from "../../lib";
import { Absence, AbsenceType } from "../../API";
import { isValidTimeOff } from "./utils";

export const useTimeOffQuery = (userId: string, dates: Interval | null) => {
  const { data, isLoading, isFetching, isPreviousData, error, ...rest } =
    useQuery(
      gqlQuery({
        req: "getEmployeeWithAbsences",
        vars: {
          id: userId,
          startDate: [
            toAWSDate(startOfYear(dates?.start ?? new Date())),
            toAWSDate(endOfYear(dates?.end ?? new Date())),
          ],
        },
        key: [userId, dates?.start ?? new Date()],
      })
    );

  const { vacationAllowance, absences, country } =
    data?.data?.getEmployee ?? {};
  const items = (absences?.items ?? []) as Absence[];

  const validItems = items.filter((i) => isValidTimeOff(i?.approvalStatus));
  const timeInLieuItems = validItems.filter(
    (i) => i.type === AbsenceType.timeInLieu
  );

  const count = (acc: number, curr: Absence) => acc + (curr?.amount ?? 0);

  const countTimeInLieuHours = (acc: number, curr: Absence) =>
    acc + (curr.hoursTaken ?? 8);

  return {
    items,
    country,
    daysUsed: validItems.reduce(count, 0),
    timeInLieuHoursUsed: timeInLieuItems.reduce(countTimeInLieuHours, 0),
    isPending: isLoading || isPreviousData || isFetching,
    error: error as Error,
    vacationAllowance,
    ...rest,
  };
};
